<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<ng-container *ngIf="isScreenSmall">
    <fuse-vertical-navigation
        class="dark bg-gray-900 print:hidden"
        [mode]="'over'"
        [name]="'mainNavigation'"
        [navigation]="navigation.default"
        [opened]="false">
        <!-- Navigation header hook -->
        <ng-container fuseVerticalNavigationContentHeader>
            <!-- Logo -->
            <div class="flex items-center h-20 pt-6 px-8">
                <img
                    class="w-24"
                    src="assets/images/logo/logo1.png"
                    alt="Logo image">
            </div>
        </ng-container>
    </fuse-vertical-navigation>
     <fuse-vertical-navigation class="bg-primary-300 print:hidden" [mode]="'over'" [name]="'B2CNavigation'"
        [navigation]="navigation?.horizontal" [opened]="false">
        <!-- Navigation header hook -->
        <ng-container fuseVerticalNavigationContentHeader>
            <!-- Logo -->
            @if(view.site) {
            <div class="flex items-center h-20 pt-6 px-8">
                <img class="w-24" [src]="view.site?.logoUrl" alt="Logo image">
            </div>
            }
        </ng-container>
    </fuse-vertical-navigation>
</ng-container>

<!-- Wrapper -->
<div class="flex flex-col flex-auto items-center w-full min-w-0 bg-primary-100 dark:bg-primary-700">

    <!-- Header -->
    <div class="relative flex flex-col flex-0 justify-center w-full h-16 sm:h-20 md:h-36 overflow-hidden z-49 shadow dark:shadow-none print:hidden">
        <!-- Top bar -->
        <div class="relative dark flex flex-auto justify-center w-full px-4 md:px-8 bg-gray-800 dark:bg-gray-900">
            <div class="flex items-center w-full max-w-360 h-16 sm:h-20">
                <!-- Logo -->
                <ng-container *ngIf="!isScreenSmall">
                    <div class="flex items-center">
                        @if(view.site) {
                            <div class="flex items-center h-16  px-2">
                                <img
                                    class="w-32"
                                    [src]="view.site?.logoUrl2"
                                    alt="Logo image">
                            </div>
                        }
                    </div>
                </ng-container>
                <!-- Navigation toggle button -->
                <ng-container *ngIf="isScreenSmall">
                     @if (!view.isClient) {
                    <button
                        class="mr-2"
                        mat-icon-button
                        (click)="toggleNavigation('mainNavigation')">
                        <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                    </button>
                }
                    <search></search>
                </ng-container>
                 @if (view.isClient) {
                <ng-container *ngIf="isScreenSmall">
                    <button mat-icon-button (click)="toggleNavigationB2C('B2CNavigation')">
                        <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                    </button>
                </ng-container>
                 }
                <!-- Components -->
                <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
                    <section>
                        <div *ngIf="view?.site" class="flex">
                            @if(view.site?.socialUrlFacebook) {
                            <div class="icons">
                                    <a href="{{view.site?.socialUrlFacebook}}" target="_blank" class="group relative w-6 h-6 mr-5  transition-all duration-500 flex justify-center items-center  hover:bg-primary-100">
                                        <mat-icon class="icon-size-4 text-white group-hover:text-primary" [svgIcon]="'feather:facebook'"></mat-icon>
                                    </a>
                                </div>
                            }
                            @if(view.site?.socialUrlInstagram) {
                            <div class="icons">
                                    <a href="{{view.site?.socialUrlInstagram}}" target="_blank" class="group relative w-6 h-6 mr-5 transition-all duration-500 flex justify-center items-center  hover:bg-primary-100">
                                        <mat-icon class="icon-size-4 text-white group-hover:text-primary" [svgIcon]="'feather:instagram'"></mat-icon>
                                    </a>
                                </div>
                            }
                            @if(view.site?.socialUrlLinkedIn) {
                            <div class="icons">
                                    <a href="{{view.site?.socialUrlLinkedIn}}" target="_blank" class="group relative w-6 h-6 mr-5  transition-all duration-500 flex justify-center items-center  hover:bg-primary-100">
                                        <mat-icon class="icon-size-4 text-white group-hover:text-primary" [svgIcon]="'feather:linkedin'"></mat-icon>
                                    </a>
                                </div>
                            }  
                        </div>
                    </section>
                    <!-- <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
                    <shortcuts></shortcuts>
                    xxx
                    <messages></messages>
                    <button
                        class="lg:hidden"
                        mat-icon-button
                        (click)="quickChat.toggle()">
                        <mat-icon [svgIcon]="'heroicons_outline:chat-bubble-left-right'"></mat-icon>
                    </button>
                    <user></user> -->
                </div>
            </div>
        </div>
        <!-- Bottom bar -->
        <ng-container *ngIf="!isScreenSmall">
            <div class="flex flex-auto justify-center px-4 md:px-8 bg-card dark:bg-gray-700">
                <div class="relative flex items-center w-full max-w-360 h-16">
                    <fuse-horizontal-navigation
                        class="-mx-4"
                        [name]="'mainNavigation'"
                        [navigation]="navigation?.horizontal"></fuse-horizontal-navigation>
                </div>
            </div>
        </ng-container>
    </div>

    <!-- Content -->
    <div class="flex flex-auto justify-center w-full sm:p-6 md:p-8">
        <div class="flex flex-col flex-auto w-full sm:max-w-360 sm:shadow-lg sm:rounded-lg sm:overflow-hidden dark:bg-accent-100">
            <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
                 Otherwise, layout changes won't be registered and the view won't be updated! -->
            <router-outlet *ngIf="true"></router-outlet>
             <!-- Dynamic cart section -->
            @if (view.isClient && view.data.cart && view.data.cart.length > 0) {
            <mat-drawer class="m-auto dark:bg-gray-900 transition-all duration-500 fixed bottom-0 shadow-2xl w-11/12 bg-white pb-5 z-99 rounded-t-lg border-2 border-b-0 border-primary opacity-[97]" [position]="'end'" [autoFocus]="false" [mode]="view.drawerOptions && view.drawerOptions.mode == 'review' ? 'side' : drawerMode" [disableClose]="false" [opened]="view.data.cart && view.data.cart.length > 0" #drawerRight>
                <cart [options]="{loadCache:false, isClient:view.isClient, compactColumns: true}" (viewChange)="viewChanged($event)" (quoteCreated)="quoteCreated($event)"></cart>
            </mat-drawer>
            }

            @if (view.isClient) {
                @if (view.site && view.site.profile && view.site.profile.sections) {
                    @switch (view.site.profile.sections.footer ) {
                        @case (1) {
                            <app-footer-type01 class="flex flex-col flex-auto items-center w-full min-w-0"></app-footer-type01>
                        }
                        @case (2) {
                            <app-footer-type02 class="flex flex-col flex-auto items-center w-full min-w-0"></app-footer-type02>
                        }
                    }
                }
            }
        </div>
    </div>

   
    <!-- Footer -->
    <!-- <div class="relative flex flex-0 justify-center w-full px-6 md:px-8 z-49 border-t bg-card print:hidden">
        <div class="flex items-center w-full max-w-360 h-14 sm:h-20">
            <span class="font-medium text-secondary">Fuse &copy; {{currentYear}}</span>
        </div>
    </div> -->

</div>

<!-- Quick chat -->
<!-- <quick-chat #quickChat="quickChat"></quick-chat> -->
